import { z } from 'zod';

export const ChangedDocumentZod = z.object({
    name: z.string(),
    type: z.string(),
    signerId: z.number(),
});

export const ChangedDocumentsZod = z.object({
    toBeUpdated: z.array(ChangedDocumentZod),
    toBeRemoved: z.array(ChangedDocumentZod),
});

export type ChangedDocument = z.infer<typeof ChangedDocumentZod>;
export type ChangedDocuments = z.infer<typeof ChangedDocumentsZod>;
